import { render, staticRenderFns } from "./PlannedTasksCalendar.vue?vue&type=template&id=23ce3828&scoped=true"
import script from "./PlannedTasksCalendar.vue?vue&type=script&lang=js"
export * from "./PlannedTasksCalendar.vue?vue&type=script&lang=js"
import style0 from "./PlannedTasksCalendar.vue?vue&type=style&index=0&id=23ce3828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ce3828",
  null
  
)

export default component.exports